export const DEFAULT_MOBWEB_TAGS_COUNT = 6;
